import React, { useState, useMemo, useEffect } from 'react';
import moment from 'moment';
import {
  Input,
  Tooltip,
  Row,
  Button,
  Modal,
  Select,
  InputNumber,
  DatePicker
} from 'antd';

import { Loadding } from '../../components';
import {
  CarOutlined,
  CloseCircleFilled,
  PlusOutlined,
  SaveOutlined,
  UndoOutlined,
  CloseOutlined
} from '@ant-design/icons';

import './style';
import { toThousands, toFixed2 } from '../../utils/Numeric';

export default React.forwardRef((props, ref) => {
  const { supplier, mode, packageList, rows, setRows, onReset, onCancel, goods, onNewCallback, onEditCallback } = props;
  const [activeIndx, setActiveIndex] = useState(undefined);
  const [remark, setRemark] = useState(packageList ? packageList.remark : '');
  const [tableRows, setTableRows] = useState([]);
  const [isLoadding, setLoadding] = useState(false);
  const [date, setDate] = useState(packageList && packageList.delivery_date ? moment(packageList.delivery_date, 'YYYY-MM-DD') : undefined);

  useEffect(() => {
    let temp = calcTableRows();
    temp = calcCartonRatio(temp);
    setTableRows(temp);
  }, [])

  useEffect(() => {

  }, [tableRows])

  const groupByRows = () => {
    const arr = [];
    let  sourceRows = JSON.parse(JSON.stringify(rows));
    let temp0 = sourceRows.filter(x=>x.pallet_id > -1);
    let temp1 = sourceRows.filter(x=>x.pallet_id === -1);

    temp0 = temp0.sort(function(a, b){return a.goods_spec_name && b.goods_spec_name ? a.goods_spec_name.localeCompare(b.goods_spec_name) : false});
    temp1 = temp1.sort(function(a, b){return a.goods_spec_name && b.goods_spec_name ? a.goods_spec_name.localeCompare(b.goods_spec_name) : false});
    sourceRows = temp0.concat(temp1);
    sourceRows.filter(row => row.goods_spec_id).forEach(x => {
      x.palletCount = undefined;
      if (!arr.find(y => y.pallet_id === x.pallet_id)) {
        const subRows = sourceRows.filter(z => z.pallet_id === x.pallet_id);
        arr.push(
          {
            pallet_id: x.pallet_id,
            palletCount: x.pallet_id > -1 ? 1 : 0,
            goodsSpecCount: subRows.length,
            goodsSpecId: subRows.length === 1 ? subRows[0].goods_spec_id : undefined,
            subRows: subRows
          }
        );
      }
    });
    return arr;
  }

  const combineRows = () => {
    const arr = [];
    const temp = groupByRows();
    console.log('temp', temp)
    temp.forEach(x => {
      let subCartonCount = 0;
      let subAmount = 0;
      x.subRows.forEach(s => {
        s.weights = s.weight * s.count;
        s.amount = s.price * s.count;
        subAmount += s.amount;
        subCartonCount += s.carton_count;
      });
      total.amounts += subAmount;
      if (x.pallet_id === -1) {
        x.subRows[0].palletCount = -1;
        total.cartons = subCartonCount;
      } else {
        x.subRows[0].palletCount = 1;
      }

      if (x.goodsSpecCount !== 1 || x.pallet_id === -1) {
        arr.push(x);
      } else {
        const find = arr.find(y => y.goodsSpecId === x.goodsSpecId);
        if (find) {
          if (find.subRows[0].carton_count / find.palletCount !== x.subRows[0].carton_count) {
            arr.push(x);
          } else {
            find.palletCount += 1;
            find.subRows[0].palletCount = find.palletCount;
            find.subRows[0].carton_count += x.subRows[0].carton_count;
            find.subRows[0].count += x.subRows[0].count;
            find.subRows[0].amount += x.subRows[0].amount;
          }
        } else {
          arr.push(x);
        }
      }
    });
    return arr;
  }

  const calcTableRows = () => {
    let arr = [];
    const temp = combineRows();
    temp.forEach(x => {
      arr = arr.concat(x.subRows);
    });
    return arr;
  }


  const chkData = () => {
    if (!date) {
      Modal.info({
        title: '发货日期',
        content: '请选择发货日期！',
      });
      return false;
    }
    if (tableRows.filter(x => x.goods_spec_id && x.count).length === 0) {
      Modal.error({
        title: '无有效数据',
        content: '请选择产品号和填写数量！',
      });
      return false;
    }

    if (tableRows.filter(x => x.goods_spec_id).length !== tableRows.filter(x => x.count).length) {
      Modal.error({
        title: '数据不完整',
        content: '同一行数据必须选择产品号和填写数量！',
      });
      return false;
    }

    if (total.pallets > 0 && tableRows[0].palletCount < 1) {
      Modal.error({
        title: '第一托盘位置',
        content: '第一托盘位置不正确，应该设置箱单第一行！',
      });
      return false;
    }

    tableRows.forEach((x, i) => {
      if (x.palletCount > 0 && x.carton_count % x.carton_count_per_pallet === 0) {
        if (tableRows[i + 1].goods_spec_id && tableRows[i + 1].carton_count && tableRows[i + 1].palletCount === undefined) {
          tableRows[i + 1].isError = true;
          tableRows[i + 1].isErrorContent = '必须选择托数或者散箱！';
        } else {
          tableRows[i + 1].isError = false;
          tableRows[i + 1].isErrorContent = undefined;
        }
      }
    });
    if (tableRows.filter(x => x.isError).length > 0) {
      const temp = [].concat(tableRows);
      setTableRows(temp);
      return false;
    }

    if (tableRows.filter(x => x.isPcsPerCartonError).length > 0) {
      Modal.error({
        title: '数据错误',
        content: '请填写正确的【件数/每箱】！',
      });
      return false;
    }

    if (tableRows.filter(x => x.isCartonCountError).length > 0) {
      Modal.error({
        title: '数据错误',
        content: '请填写正确的【箱数】！',
      });
      return false;
    }

    if (tableRows.filter(x => x.isCartonRatioError).length > 0) {
      Modal.error({
        title: '数据错误',
        content: '请修改正确的【箱比】！',
      });
      return false;
    }

    // check order count
    /*
    if (mode === 'new') {
      const goods_spec_ids = [];
      tableRows.forEach(x=>{
        const find = goods_spec_ids.find(y => y.goods_spec_id === x.goods_spec_id);
        if (!find) {
          goods_spec_ids.push({goods_spec_id: x.goods_spec_id, count: x.count});
        } else {
          find.count += x.count;
        }
      })
      for (let i=0; i< goods_spec_ids.length; i++) {
        const x = goods_spec_ids[i];
        const finds = goods.filter(y=>y.goods_spec_id === x.goods_spec_id);
        if (finds.length > 1) {
          let temp_count = 0;
          finds.forEach(x=>{
            temp_count += (x.adjust_count - x.count);
          })
          if (temp_count < x.count) {
            Modal.error({
              title: '数据错误',
              content: <span>产品号：{finds[0].goods_spec_name}，<br/>箱单填写数量超过剩余数量（{temp_count}）！</span>,
            });
            return false;
          }
        } else if (finds.length === 1) {
          if ((finds[0].adjust_count - finds[0].ok_count) < x.count) {
            Modal.error({
              title: '数据错误',
              content: <span>产品号：{finds[0].goods_spec_name}，<br/>箱单填写数量超过剩余数量（{finds[0].adjust_count - finds[0].ok_count}）！</span>,
            });
            return false;
          }
        }
      }
    }*/
    return true;
  }

  const confirm = () => {
    const isError = false;
    onSaveData(isError);
  }

  const onSaveData = (isError) => {
    let pallets = [];
    let cartons = [];
    if (total.pallets === 0) {
      for (let i = 0; i < tableRows.length; i++) {
        const x = tableRows[i];
        if (x.goods_spec_id && x.count) cartons.push(x);
      }
    } else {
      const palletIds = [];
      tableRows.filter(row => row.pallet_id > -1).forEach(x => {
        if (!palletIds.find(y => y.pallet_id === x.pallet_id)) {
          palletIds.push({
            pallet_id: x.pallet_id,
            data: tableRows.filter(f => f.pallet_id === x.pallet_id)
          });
        }
      });
      palletIds.forEach(x => {
        if (x.data.length > 1) {
          pallets.push(x.data);
        } else if (x.data.length === 1) {
          if (x.data[0].palletCount > 1) {
            for (let i = 0; i < x.data[0].palletCount; i++) {
              const temp = {
                ...x.data[0],
                carton_count: x.data[0].carton_count / x.data[0].palletCount,
                count: x.data[0].count / x.data[0].palletCount,
              };
              pallets.push([temp]);
            }
          } else {
            pallets.push(x.data);
          }
        }
      });
      cartons = tableRows.filter(x => x.pallet_id === -1);
    }
    console.log(pallets, cartons);
    if (mode === 'new') {
      onNewCallback && onNewCallback({ pallets, cartons, remark, date, isError });
    } else if (mode === 'edit') {
      onEditCallback && onEditCallback({ packageList, pallets, cartons, remark, date, isError });
    }
  }
  const onSave = () => {
    if (!chkData()) return;
    confirm();
  }

  const onNewLine = () => {
    const temp = [].concat(rows).concat(
      [{}, {}, {}, {}, {}]
    );
    setRows(temp);
  }

  const goodsSpecOption = () => {
    const temp = [];
    goods.map((item, index) => {
      const exist = temp.find(x => x.goods_spec_id === item.goods_spec_id);
      if (!exist) {
        temp.push({
          goods_spec_id: item.goods_spec_id,
          goods_spec_name: item.goods_spec_name,
          goods_id: item.goods_id,
          goods_name: item.goods_name,
          size: item.size,
          weight: item.weight,
          price: item.price
        })
      }
    });
    return temp;
  }

  const onChangePallet = (item, index) => {
    let temp = [].concat(tableRows);
    const find = temp[index];
    if (find && (!find.palletCount || (find.palletCount <= 1 && find.carton_count !== find.carton_count_per_pallet))) {
      find.palletCount = item;
      if (find.isError) {
        find.isError = undefined;
        find.isErrorContent = undefined;
      }
      temp = calcPalletId(temp);
      temp = calcCartonRatio(temp);
      setTableRows(temp);
    }
  }

  const onChangeRemark = (e) => {
    setRemark(e.target.value);
  }

  const onChangeCount = (item, index, pcs_per_carton) => {
    const temp = [].concat(rows);
    const find = temp[index];
    if (find) {
      find.count = Math.ceil(item / pcs_per_carton) * pcs_per_carton;
      setRows(temp);
    }
  }
  const onChangeGoods = (item, index) => {
    if (!item) {
      const temp = [].concat(tableRows);
      temp[index] = {};
      setTableRows(temp);
      return;
    }
    const find = goods.find(x => x.goods_spec_id === item);
    if (find) {
      const temp = [].concat(tableRows);
      temp[index].goods_id = find.goods_id;
      temp[index].goods_spec_id = find.goods_spec_id;
      temp[index].goods_name = find.goods_name;
      temp[index].size = find.size;
      temp[index].weight = find.weight;
      temp[index].price = find.price;
      temp[index].pcs_per_carton = find.pcs_per_carton;
      temp[index].carton_count_per_pallet = find.carton_count_per_pallet;
      temp[index].ok_count = find.ok_count;
      temp[index].adjust_count = find.adjust_count;
      setTableRows(temp);
    }
  }
  const renderRemark = () => {
    if (mode === 'view') {
      return <span>{packageList.remark} {packageList.delivery_date && '发货日期：' + packageList.delivery_date}</span>
    }
    return <Input value={remark} onChange={onChangeRemark} className="test" size="small"></Input>;
  }

  const RenderFooter = () => {
    const temp = [];
    temp.push(
      <tr>
        <td className="td-center td-border-right-black-1">
          总数:
        </td>
        <td colSpan={4} className="td-center td-border-right-black-1">
          {total.pallets}托 + {total.cartons}散箱
        </td>
        <td className="td-center td-border-right-black-1"></td>
        <td className="td-center td-border-right-black-1"></td>
        <td className="td-center td-border-right-black-1"></td>
        <td className="td-center td-border-right-black-1"></td>
        <td className="td-right td-border-right-black-1">
          {toThousands(toFixed2(total.weights * 0.001, 1))}
        </td>
        <td className="td-center td-border-right-black-1">KGS</td>
        <td className="td-center td-border-right-black-1"></td>

        <td className="td-right td-border-right-black-1">
          {toThousands(toFixed2(total.amounts, 2))}
        </td>
        <td className="td-center td-border-right-black-1"></td>
        <td className="td-center td-border-right-black-1"></td>
        <td className="td-center td-border-right-black-1"></td>
        <td className="td-center td-border-right-black-1"></td>
        <td></td>
      </tr>
    );
    temp.push(<tr>
      <td className="td-center td-border-right-black-1">
        备注
      </td>
      <td colSpan={17}>
        {
          useMemo(() => renderRemark(), [remark])
        }
      </td>
    </tr>)
    return temp;
  }

  const handleDblClickRow = (i) => {
    const temp = [].concat(rows);
    temp.splice(i, 0, { ...temp[i] });
    setRows(temp);
  }

  const handleDeleteClickRow = (i) => {
    const temp = [].concat(rows);
    temp.splice(i, 1);
    setRows(temp);
  }

  const calcPalletId = (tempRows) => {
    let oldId = undefined;
    tempRows.filter(f => f.goods_spec_id).forEach((x, i) => {
      if (x.palletCount !== undefined) {
        x.pallet_id = i;
        oldId = i;
        if (x.palletCount === -1) {
          x.pallet_id = -1;
          oldId = -1;
        }
      } else {
        x.pallet_id = oldId;
      }
    });
    return tempRows;
  }
  const calcCartonRatio = (tempRows) => {
    tempRows.filter(f => f.palletCount > 0).forEach(x => {
      const temp = tempRows.filter(y => y.pallet_id === x.pallet_id);
      let ratio = 0;
      let weights = 0;
      temp.forEach(s => {
        weights += (s.count * s.weight);
        ratio += ((s.count / s.pcs_per_carton) / s.carton_count_per_pallet);
        s.cartonRatio = undefined;
        s.totalWeights = undefined;
        s.isCartonRatioError = undefined;
      });
      temp[0].cartonRatio = ratio / x.palletCount;
      temp[0].totalWeights = weights;
      if (temp[0].cartonRatio > supplier.pallet_ratio) {
        temp[0].isCartonRatioError = true;
      } else {
        temp[0].isCartonRatioError = false;
      }
      if (temp[0].totalWeights / x.palletCount > supplier.pallet_max * 1000) {
        temp[0].isPalletWeightError = true;
      } else {
        temp[0].isPalletWeightError = false;
      }
    });
    return tempRows;
  }

  const total = useMemo(() => {
    let pallets = 0, cartons = 0, weights = 0, amounts = 0;
    tableRows.filter(f => f.goods_spec_id && f.count).forEach(x => {
      x.palletCount > 0 && (pallets += x.palletCount);
      x.pallet_id === -1 && (cartons += x.carton_count);
      weights += (x.count * x.weight);
      amounts += (x.count * x.price);
    });
    return {
      pallets,
      cartons,
      weights,
      amounts
    }
  }, [tableRows])

  const handleCartonCount = (i, value) => {
    const temp = [].concat(tableRows);
    temp[i].carton_count = value;
    if (temp[i].pcsPerCarton) {
      temp[i].count = value * temp[i].pcsPerCarton;
      temp[i].amount = temp[i].count * temp[i].price;
    }
    setTableRows(temp);
  }

  const handleCartonCountBlur = (i, e) => {
    let temp = [].concat(tableRows);
    const value = parseInt(e.target.value);
    if (temp[i].carton_count_per_pallet) {
      if (value % temp[i].carton_count_per_pallet === 0 && value >= temp[i].carton_count_per_pallet) {
        temp[i].palletCount = value / temp[i].carton_count_per_pallet;
        temp[i].isCartonCountError = false;
        temp[i].weights = temp[i].count * temp[i].weight / temp[i].palletCount;
      } else if (value % temp[i].carton_count_per_pallet > 0 && value >= temp[i].carton_count_per_pallet) {
        temp[i].isCartonCountError = true;
      } else {
        if (temp[i].palletCount > 1) {
          temp[i].palletCount = 1;
        };
        temp[i].weights = temp[i].count * temp[i].weight;
        temp[i].isCartonCountError = false;
      }
      temp = calcPalletId(temp);
      temp = calcCartonRatio(temp);
      setTableRows(temp);
    }
  }

  const handlePcsCarton = (i, value) => {
    const temp = [].concat(tableRows);
    temp[i].pcsPerCarton = value;
    if (temp[i].carton_count) {
      temp[i].count = value * temp[i].carton_count;
      temp[i].amount = temp[i].count * temp[i].price;
    }
    setTableRows(temp);
  }

  const handlePcsCartonBlur = (i, e) => {
    let temp = [].concat(tableRows);
    const value = parseInt(e.target.value);
    if (temp[i].pcs_per_carton) {
      if (temp[i].pcs_per_carton !== value) {
        temp[i].isPcsPerCartonError = true;
      } else {
        temp[i].isPcsPerCartonError = false;
      }
      if (temp[i].palletCount > 0) {
        temp[i].weights = temp[i].count * temp[i].weight / temp[i].palletCount;
      } else {
        temp[i].weights = temp[i].count * temp[i].weight;
      }
      temp = calcPalletId(temp);
      temp = calcCartonRatio(temp);
      setTableRows(temp);
    }
  }

  const renderCartonCountInputNumber = (i, x, cnt, validCnt, handleInput, handleBlur = undefined) => {
    if (mode === 'view') {
      return <span>{cnt}</span>;
    }
    return <div style={{ position: 'relative' }}>
      <InputNumber
        allowClear={true}
        key={'cartongcount_' + i}
        keyboard={false}
        style={{ width: '100%', left: 0, backgroundColor: x.goods_spec_id ? cnt ? 'yellow' : 'red' : undefined }}
        onFocus={() => setActiveIndex(i)}
        onBlur={handleBlur ? (value) => handleBlur(i, value) : undefined}
        onChange={(value) => handleInput(i, value)}
        className="test"
        size="small"
        min={1} value={cnt}>
      </InputNumber>
      {
        (x.palletCount === 0) && <span style={{ position: 'absolute', cursor: 'pointer', color: 'red', top: '2px', right: '5px' }} role="img" aria-label="close-circle" class="">
          <Tooltip placement="topLeft" title={`正确值：${validCnt}整数倍`} arrowPointAtCenter>
            <svg viewBox="64 64 896 896" focusable="false" data-icon="close-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path></svg>
          </Tooltip>
        </span>
      }
    </div>
  }

  const renderInputNumber = (i, x, cnt, validCnt, handleInput, handleBlur = undefined) => {
    if (mode === 'view') {
      return <span>{cnt}</span>;
    }
    const isError = rows[i].isError;
    if (!handleBlur || !x.goods_spec_id || !isError) {
      return <InputNumber
        keyboard={false}
        style={{ backgroundColor: x.goods_spec_id ? cnt ? 'yellow' : 'red' : undefined }}
        onFocus={() => setActiveIndex(i)}
        onBlur={handleBlur ? (value) => handleBlur(i, value) : undefined}
        onChange={(value) => handleInput(i, value)}
        className="test"
        size="small"
        min={1} value={cnt}>
      </InputNumber>
    }
    return <div style={{ position: 'relative' }}>
      <InputNumber
        keyboard={false}
        style={{ left: 0, backgroundColor: x.goods_spec_id ? cnt ? 'yellow' : 'red' : undefined }}
        onFocus={() => setActiveIndex(i)}
        onBlur={handleBlur ? (value) => handleBlur(i, value) : undefined}
        onChange={(value) => handleInput(i, value)}
        className="test"
        size="small"
        min={1} value={cnt}>
      </InputNumber>
      <span style={{ position: 'absolute', cursor: 'pointer', color: 'red', top: '2px', right: '5px' }} role="img" aria-label="close-circle" class="">
        <Tooltip placement="topLeft" title={`正确值：${validCnt}`} arrowPointAtCenter>
          <svg viewBox="64 64 896 896" focusable="false" data-icon="close-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path></svg>
        </Tooltip>
      </span>
    </div>
  }

  const renderRowsView = () => {
    const tempRows = tableRows;
    const temp = [];
    tempRows.forEach((x, i) => {
      temp.push(<tr style={{ backgroundColor: activeIndx === i ? 'rgb(220, 222, 245)' : undefined }} >
        <td className="td-center td-border-right-black-1"></td>
        <td className="td-center td-border-right-black-1">
          {x.palletCount >= 1 && x.palletCount}
          {x.palletCount === -1 && '散'}
        </td>
        <td className="td-border-right-1">
          {x.goods_spec_name}
        </td>
        <td style={{ paddingLeft: '5px' }} className="td-border-right-1">{x.goods_name}</td>
        <td className="td-center td-border-right-black-1">{x.size}</td>
        <td className="td-center td-border-right-black-1">
          {x.goods_spec_id && toThousands(x.carton_count_per_pallet)}
        </td>
        <td className="td-right td-border-right-black-1">
          {x.carton_count}
        </td>
        <td className="td-center td-border-right-black-1">
          {x.pcs_per_carton}
        </td>
        <td className="td-center td-border-right-black-1">
          {x.count}
        </td>
        <td className="td-right td-border-right-black-1">
          {toThousands(toFixed2(x.weights * 0.001, 1))}
        </td>
        <td className="td-right td-border-right-black-1">
          {x.totalWeights && toThousands(toFixed2(x.totalWeights * 0.001, 1))}
        </td>
        <td className="td-right td-border-right-black-1">
          {toThousands(toFixed2(x.price, 3))}
        </td>
        <td className="td-right td-border-right-black-1">
          {toThousands(toFixed2(x.amount, 2))}
        </td>
        <td className="td-center td-border-right-black-1"></td>
        <td className="td-center td-border-right-black-1"></td>
        <td className="td-center td-border-right-black-1">&nbsp;</td>
        <td className="td-center td-border-right-black-1"></td>
        <td className="td-center">
          {x.cartonRatio <= supplier.pallet_ratio && '箱比:' + toFixed2(x.cartonRatio, 1)}
          {x.cartonRatio > supplier.pallet_ratio && <Tooltip title={`托盘最大托比：${supplier.pallet_ratio}`}> <span style={{ color: 'red', fontWeight: '600' }}> 箱比:{toFixed2(x.cartonRatio, 1)}</span></Tooltip>}
        </td>
      </tr>);
    });
    return temp;
  }

  const renderRowsEdit = () => {
    const tempRows = tableRows;
    if (tempRows.length < 17) {
      for (let i = tempRows.length; i < 17; i++) {
        tempRows.push({});
      }
    }
    const temp = [];
    tempRows.forEach((x, i) => {
      temp.push(<tr style={{ backgroundColor: activeIndx === i ? 'rgb(220, 222, 245)' : undefined }} >
        <td className="td-left td-border-right-black-1">
          <span style={{ color: "#777777" }}>{i + 1}</span>
        </td>
        <td className="td-center td-border-right-black-1">
          <div style={{ position: 'relative' }}>
            <Select value={x.palletCount} onChange={(e) => onChangePallet(e, i)} allowClear className="test" size="small">
              {x.carton_count < x.carton_count_per_pallet && [{ label: 1, value: 1 }, { label: '散', value: -1 }].map(p => {
                return <Select.Option key={p.label} value={p.value}>
                  {p.label}
                </Select.Option>
              })}
              {x.palletCount > 0 && [{ label: x.palletCount, value: x.palletCount }].map(p => {
                return <Select.Option key={p.label} value={p.value}>
                  {p.label}
                </Select.Option>
              })}
              {!x.goods_spec_id && [{ label: 1, value: 1 }, { label: '散', value: -1 }].map(p => {
                return <Select.Option key={p.label} value={p.value}>
                  {p.label}
                </Select.Option>
              })}
            </Select>
            {x.isError && <span style={{ position: 'absolute', cursor: 'pointer', color: 'red', top: '2px', left: '4px' }} role="img" aria-label="close-circle" class="">
              <Tooltip placement="topLeft" title={x.isErrorContent} arrowPointAtCenter>
                <svg viewBox="64 64 896 896" focusable="false" data-icon="close-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path></svg>
              </Tooltip>
            </span>}
          </div>
        </td>
        <td className="td-border-right-1">
          <Select
            showSearch
            optionFilterProp="children"
            value={x.goods_spec_id}
            onFocus={() => setActiveIndex(i)}
            allowClear
            onChange={(e) => onChangeGoods(e, i)}
            className="test"
            size="small">
            {
              goodsSpecOption().map(g => {
                return <Select.Option
                  key={g.goods_spec_id}
                  value={g.goods_spec_id}>
                  {g.goods_spec_name}
                </Select.Option>
              })
            }
          </Select>
        </td>
        <td style={{ paddingLeft: '5px' }} className="td-border-right-1">{x.goods_name}</td>
        <td className="td-center td-border-right-black-1">{x.size}</td>
        <td className="td-center td-border-right-black-1">
          {x.goods_spec_id && toThousands(x.carton_count_per_pallet)}
        </td>
        <td className="td-right td-border-right-black-1">
          <div style={{ position: 'relative' }}>
            <InputNumber
              allowClear={true}
              key={'cartongcount_' + i}
              keyboard={false}
              style={{ width: '100%', left: 0, backgroundColor: x.goods_spec_id ? x.carton_count ? 'yellow' : 'red' : undefined }}
              onFocus={() => setActiveIndex(i)}
              onBlur={(value) => handleCartonCountBlur(i, value)}
              onChange={(value) => handleCartonCount(i, value)}
              className="test"
              size="small"
              min={1} value={x.carton_count}>
            </InputNumber>
            {
              x.isCartonCountError && <span style={{ position: 'absolute', cursor: 'pointer', color: 'red', top: '2px', right: '5px' }} role="img" aria-label="close-circle" class="">
                <Tooltip placement="topLeft" title={`正确值：${x.carton_count_per_pallet}整数倍`} arrowPointAtCenter>
                  <svg viewBox="64 64 896 896" focusable="false" data-icon="close-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path></svg>
                </Tooltip>
              </span>
            }
          </div>
        </td>
        <td className="td-center td-border-right-black-1">
          <div style={{ position: 'relative' }}>
            <InputNumber
              keyboard={false}
              style={{ left: 0, backgroundColor: x.goods_spec_id ? x.pcsPerCarton ? 'yellow' : 'red' : undefined }}
              onFocus={() => setActiveIndex(i)}
              onBlur={(value) => handlePcsCartonBlur(i, value)}
              onChange={(value) => handlePcsCarton(i, value)}
              className="test"
              size="small"
              min={1} defaultValue={x.pcs_per_carton} value={x.pcsPerCarton}>
            </InputNumber>
            {
              x.isPcsPerCartonError && <span style={{ position: 'absolute', cursor: 'pointer', color: 'red', top: '2px', right: '5px' }} role="img" aria-label="close-circle" class="">
                <Tooltip placement="topLeft" title={`正确值：${x.pcs_per_carton}`} arrowPointAtCenter>
                  <svg viewBox="64 64 896 896" focusable="false" data-icon="close-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path></svg>
                </Tooltip>
              </span>
            }
          </div>
        </td>
        <td className="td-center td-border-right-black-1">
          {x.count}
        </td>
        <td className="td-right td-border-right-black-1">
          {x.weights && toThousands(toFixed2(x.weights * 0.001, 1))}
        </td>
        <td className="td-right td-border-right-black-1">

          {x.totalWeights && toThousands(toFixed2(x.totalWeights * 0.001, 1))}
          {
            x.isPalletWeightError && <span style={{ cursor: 'pointer', color: 'red', top: '2px', right: '5px' }} role="img" aria-label="close-circle" class="">
              <Tooltip placement="topLeft" title={`托盘最大允许重量：${supplier.pallet_max}KGS`} arrowPointAtCenter>
                <svg viewBox="64 64 896 896" focusable="false" data-icon="close-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path></svg>
              </Tooltip>
            </span>
          }

        </td>
        <td className="td-right td-border-right-black-1">
          {x.price && toThousands(toFixed2(x.price, 3))}
        </td>
        <td className="td-right td-border-right-black-1">
          {x.amount && toThousands(toFixed2(x.amount, 2))}
        </td>
        <td className="td-center td-border-right-black-1"></td>
        <td className="td-center td-border-right-black-1"></td>
        <td className="td-center td-border-right-black-1">&nbsp;</td>
        <td className="td-center td-border-right-black-1"></td>
        <td className="td-center">
          {x.isCartonRatioError === false && '箱比:' + toFixed2(x.cartonRatio, 1)}
          {x.isCartonRatioError === true && <Tooltip title={`托盘最大托比：${supplier.pallet_ratio}`}> <span style={{ color: 'red', fontWeight: '600' }}> 箱比:{toFixed2(x.cartonRatio, 1)}</span></Tooltip>}
        </td>
      </tr>);
    });
    return temp;
  }

  return (
    <p>
      {
        mode !== 'view' && <Row style={{ paddingBottom: '0.5rem' }} gutter={[0, 16]}>
          <span style={{ fontSize: '1.5rem', lineHeight: '2.5rem', paddingRight: '0.5rem' }}>状态：<strong>{mode === 'edit' ? ('修改装箱单[' + packageList.no + ']') : '新建装箱单'}</strong></span>
          {mode === 'edit' && <Button danger onClick={() => onCancel(undefined)} icon={<UndoOutlined />} type="primary" >取消本次修改</Button>}
          <Button hidden={true} onClick={onNewLine} style={{ marginLeft: 'auto' }} icon={<PlusOutlined />} >添加新空行</Button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span style={{ marginLeft: 'auto', fontSize: '1.5rem', lineHeight: '2.5rem' }}>发货日期：</span><DatePicker allowClear={false} value={date} onChange={(value) => setDate(moment(value, 'YYYY-MM-DD'))} placeholder="请选择发货日期" />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Button danger onClick={() => onReset(undefined)} icon={<CloseOutlined />}>清空重填</Button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Button onClick={onSave} icon={<SaveOutlined />} type="primary" >保存并生成装箱单</Button>
        </Row>
      }
      <table className="pkg-list-table">
        <thead>
          <tr>
            <th rowSpan={2} width="64px" className="td-center td-border-right-black-1">唛头<br />PLT NO.</th>
            <th rowSpan={2} width="56px" className="td-center td-border-right-black-1">托数</th>
            <th className="td-center td-border-right-black-1" colSpan={3}>品名及规格<br />DESCRIPTION</th>
            <th rowSpan={2} width="56px" className="td-center td-border-right-black-1">箱数/托<br />CTN PALLET</th>
            <th rowSpan={2} width="96px" className="td-center td-border-right-black-1">箱数<br />CTN</th>
            <th width="156px" className="td-center td-border-right-black-1" colSpan={2}>数量QUANTITY</th>
            <th rowSpan={2} width="72px" className="td-center td-border-right-black-1">重量<br />KG</th>
            <th rowSpan={2} width="72px" className="td-center td-border-right-black-1">总重<br />KG</th>
            <th width="166px" className="td-center td-border-right-black-1" colSpan={2}>金额AMOUNT</th>
            <th rowSpan={2} width="40px" className="td-center td-border-right-black-1">托<br />盘<br />明<br />细</th>
            <th rowSpan={2} width="40px" className="td-center td-border-right-black-1">产<br />品<br />标<br />签</th>
            <th rowSpan={2} width="40px" className="td-center td-border-right-black-1">唛<br />头</th>
            <th rowSpan={2} width="64px" className="td-center td-border-right-black-1">收货日期</th>
            <th rowSpan={2} width="72px" className="td-center">备注</th>
          </tr>
          <tr>
            <th className="td-center td-border-right-1">产品号</th>
            <th className="td-center td-border-right-1">产品名称及表面</th>
            <th className="td-center td-border-right-black-1">尺寸</th>
            <th style={{ fontSize: '10px' }} className="td-center td-border-right-1">件数/每箱<br />PCS/CARTON</th>
            <th className="td-center td-border-right-black-1">总数<br />TOTAL</th>
            <th width="80px" style={{ width: "80px", fontSize: '10px' }} className="td-center td-border-right-1">单价<br />UNIT PRICE</th>
            <th style={{ fontSize: '12px' }} className="td-center td-border-right-black-1">总金额<br />&nbsp;&nbsp;AMOUNT&nbsp;&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {
            isLoadding && <Loadding />
          }
          {
            mode === 'view' && renderRowsView()
          }
          {
            mode === 'edit' && renderRowsEdit()
          }
          {
            mode === 'new' && renderRowsEdit()
          }
        </tbody>
        <tfoot>
          {
            RenderFooter()
          }
        </tfoot>
      </table>
      <br />
      {
        mode !== 'view' && <Row gutter={[0, 16]}>
          <Button hidden={true} onClick={onNewLine} style={{ marginLeft: 'auto' }} icon={<PlusOutlined />} >添加新空行</Button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Button danger style={{ marginLeft: 'auto' }} onClick={() => onReset(undefined)} icon={<CarOutlined />}>清空重填</Button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Button onClick={onSave} icon={<CarOutlined />} type="primary" >保存并生成装箱单</Button>
        </Row>
      }
    </p>
  );
});
